import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = (scrolled) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      dotsBtnWrapper: {
        marginLeft: 0,
        position: 'relative',
        display: 'block',
      },
      dotsBtn: {
        padding: 12,
      },
      dotsBtnIcon: {
        width: 18,
        height: 18,
      },
      dropdown: {
        borderRadius: 10,
        background: theme.palette.secondary.light,
        zIndex: 1150,
        boxShadow: '0px 13px 26px rgba(0, 0, 0, 0.3)',
        minWidth: 240,
        maxWidth: 240,
        position: 'absolute',
        right: -2,
        top: scrolled ? 70 : 80,
        transition: 'all .5s ease-in-out',
        display: 'none',
        '&$dropdownOpened': {
          [theme.breakpoints.up('md')]: {
            display: 'block',
          },
        },
      },
      dropdownOpened: {},
      dropdownContent: {
        position: 'relative',
        '&::before': {
          content: '""',
          display: 'block',
          width: 18,
          height: 18,
          background: theme.palette.secondary.light,
          transform: 'rotate(45deg)',
          position: 'absolute',
          top: -9,
          right: 'calc(50% - 9px)',
          [theme.breakpoints.up('sm')]: {
            right: 20,
          },
        },
      },
      divider: {
        position: 'relative',
        padding: `24px 24px ${SMALL_MARGIN}px`,
        marginBottom: 9,
        '&::after': {
          content: '""',
          display: 'block',
          width: 'calc(100% - 48px)',
          height: 1,
          background: colorsPalette.white,
          opacity: 0.33,
          position: 'absolute',
          bottom: 0,
        },
        '& $username:not(:only-child)': {
          marginBottom: 10,
        },
        '& $username:only-child': {
          marginBottom: 0,
        },
      },
      logout: {
        marginTop: SMALL_MARGIN,
        padding: '9px 0',
        background: colorsPalette.violetAnalyticsCard,
        borderRadius: '0 0 10px 10px',
        display: 'flex',
      },
      username: {
        color: colorsPalette.white,
        fontSize: 18,
        lineHeight: 1.2,
        fontWeight: 'bold',
        marginBottom: 5,
        display: 'none',
        [theme.breakpoints.up('xl')]: {
          display: 'block',
        },
      },
      team: {
        fontSize: 14,
        color: colorsPalette.gray,
        lineHeight: 1.5,
      },
      linksWrapper: {
        display: 'flex',
        flexDirection: 'column',
      },
      dropdownLink: {
        border: 'none',
        background: 'transparent',
        textTransform: 'uppercase',
        color: colorsPalette.white,
        fontWeight: 'bold',
        fontSize: 14,
        padding: '9px 24px',
        width: '100%',
        transition: 'background .3s',
        cursor: 'pointer',
        '&:hover': {
          background: colorsPalette.violetAnalyticsCard,
        },
        '&:last-child': {
          marginBottom: 0,
        },
      },
    });
  });

export default useStyles;
